import VideoPage from './component/VideoPage'

function App() {
  return (
    <div className="App">
      <VideoPage />
    </div>
  );
}

export default App;
